import { render, staticRenderFns } from "./biography.vue?vue&type=template&id=08f2f9e9&scoped=true&"
import script from "./biography.vue?vue&type=script&lang=js&"
export * from "./biography.vue?vue&type=script&lang=js&"
import style0 from "./biography.vue?vue&type=style&index=0&id=08f2f9e9&scoped=true&lang=css&"
import style1 from "./biography.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f2f9e9",
  null
  
)

export default component.exports